import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/not-found.tsx");
